import {Stack} from 'shells/layout/stack/stack';
import {StatusBadge} from 'shells/status-badge/status-badge';
import {Body} from 'shells/typography/body';

import {
    FromDomainStatus,
    type GetSharedInboxConfig_sharedInboxConfig_sharedAddresses_fromDomain as FromDomainConfig,
} from 'nutshell-graphql-types';

import {getDnsRecords} from './helpers';

interface Props {
    fromDomain: FromDomainConfig;
}

export function DnsRecordList(props: Props) {
    const records = getDnsRecords(props.fromDomain);

    return (
        <div className='px-16 py-8'>
            <Stack spacing={8}>
                {records.map((record) => {
                    const recordVerified = record.status === FromDomainStatus.STATUS_VERIFIED;

                    return (
                        <div
                            key={record.label}
                            className='border br-8 pad-16 bg-white justify-sb flex'
                        >
                            <div className='flex align-center gap-8'>
                                <Body isBold={true} size='small' color='dark'>
                                    {record.label}
                                </Body>
                                <Body size='small' color='medium'>
                                    {record.fullName}
                                </Body>
                            </div>
                            <StatusBadge
                                level={recordVerified ? 'success' : 'warning'}
                                text={recordVerified ? 'Verified' : 'Unverified'}
                            />
                        </div>
                    );
                })}
            </Stack>
        </div>
    );
}
